import type { AppState } from 'state/state.model';

export function getSecondaryMarketRealtimeBcsProduct(state: AppState, rowId: string) {
  return state.secondaryMarket.referential.bcsProduct[rowId];
}

export function hasSecondaryMarketRealtimeBcsProductLoaded(state: AppState, rowId: string) {
  return getSecondaryMarketRealtimeBcsProduct(state, rowId) !== undefined;
}
